<div style="width: 100%; position: relative;">
    <input 
        [type]="isPasswordVisible ? 'text' : 'password'" 
        [value]="password"
        (input)="passwordChange.emit($event.target.value)" 
        [id]="id"
        [name]="name"
        [placeholder]="placeholder" 
        [class]="class"
        [ngClass]="ngClass"
        [tabindex]="tabindex"
        required
        class="form-control"
        />

        <!-- Icon -->
        <i
            class="fad" 
            [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'" 
            (click)="togglePasswordVisibility()" 
            [style]="isPasswordVisible 
                ? 'position: absolute; right: 8px; top: 50%; transform: translateY(-50%); cursor: pointer;' 
                : 'position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;'">
        </i>
</div>
